import api from '@/utils/http'

/**
 功能：列表
 time: 2025-13-01 17:13:44
 **/
export function getAdminList(data) {
    return api.post('/admin/admin/getList', data)
}

/**
 功能：保存
 time: 2025-38-02 16:38:38
 **/
export function saveAdmin(data) {
    return api.post('/admin/admin/eSave', data)
}

/**
 功能：
 time: 2025-42-02 16:42:10
 **/
export function getAdminDetail(admin_id) {
    return api.post('/admin/admin/getDetail', { admin_id: admin_id })
}

/**
 功能：
 time: 2025-20-02 17:20:52
 **/
export function deleteAdmin(admin_id) {
    return api.post('/admin/admin/del', {admin_id: admin_id})
}

